module.exports = __webpack_public_path__ + "img/client-1.64bd52dc.png";